import { Component, OnInit } from '@angular/core';
import { PropertyByNamePipe } from '../../pipes/property-by-name';
import { ApiService } from '../../services/api.service';
import { Item } from '../../models/item.model';
import {Automobilia} from '../../models/automobilia.model';
import { HttpClient } from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {WantedItem} from '../../models/wanted-item.model';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html'
})
export class OverviewComponent implements OnInit {

  items: Array<Item>;

  vehicles: Array<any>;

  automobilia: Array<Automobilia>;

  wantedItems: Array<WantedItem>

  automobiliaSlider = [];
  carsWantedSlider = [];

  vehicleImages = [
    '../../../assets/images/vehicles.jpg'
  ];
  emptyVehicleImages = [
    '../../../assets/images/placeholder-vehicles-small.jpg'
  ];
  emptyAutomobiliaImages = [
    '../../../assets/images/placeholder-automobilia.jpg'
  ];
  emptyCarsWantedImages = [
    '../../../assets/images/placeholder-cars-wanted.jpg'
  ];
  automobiliaImages = [
    '../../../assets/images/automobilia.jpg'
  ];
  carsWantedImages = [
    '../../../assets/images/cars-wanted.jpg'
  ];

  constructor(private api: ApiService,
              private propertyByNamePipe: PropertyByNamePipe,
              private http: HttpClient,
              private translate: TranslateService) {

  }

  ngOnInit() {
    this.api.getSharedItems().subscribe(
      (res: Item[]) => {
        this.items = res as Item[];
        if (this.items.length > 0) {

          this.vehicles = [];
          this.vehicleImages.forEach(
            (elem) => {
              this.vehicles.push(
                {
                  image: elem,
                  subline : '_OVERVIEW.SLIDER.VEHICLES.SUBLINE',
                  value: this.items.length,
                  link : '/list',
                  linktext: '_OVERVIEW.SLIDER.VEHICLES.BUTTON',
                  spacing: false
                }
              );

            }
          );
        } else {
          this.vehicles = [];
          this.emptyVehicleImages.forEach(
            (elem) => {
              this.vehicles.push(
                {
                  image: elem,
                  subline : '_OVERVIEW.NO_VEHICLES',
                  value: this.items.length
                }
              );

            }
          );
        }
      }
    );
    this.api.getAutomobiliaForSale().subscribe(
      (res: Automobilia[]) => {
        this.automobilia = res;
        if (this.automobilia.length > 0) {
          this.automobiliaImages.forEach(
            (elem) => {
              this.automobiliaSlider.push(
                {
                  image: elem,
                  subline: '_OVERVIEW.SLIDER.AUTOMOBILIA.SUBLINE',
                  link: '/automobilia',
                  linktext: '_OVERVIEW.SLIDER.AUTOMOBILIA.BUTTON',
                  spacing: true,
                  value: this.automobilia.length
                }
              );
            }
          );
        } else {
          this.emptyAutomobiliaImages.forEach(
            (elem) => {
              this.automobiliaSlider.push(
                {
                  image: elem,
                  subline: '_OVERVIEW.SLIDER.AUTOMOBILIA.SUBLINE',
                  value: this.automobilia.length
                }
              );
            }
          );
        }
      }
    );
    this.api.getWantedItemsActive(true).subscribe(
      (res: WantedItem[]) => {
        this.wantedItems = res;
        if (this.wantedItems.length > 0) {
          this.carsWantedImages.forEach(
            (elem) => {
              this.carsWantedSlider.push(
                {
                  image: elem,
                  subline: '_OVERVIEW.SLIDER.CARS_WANTED.SUBLINE',
                  link: '/cars-wanted',
                  linktext: '_OVERVIEW.SLIDER.CARS_WANTED.BUTTON',
                  spacing: true,
                  value: this.wantedItems.length
                }
              );
            }
          );
        } else {
          this.emptyCarsWantedImages.forEach(
            (elem) => {
              this.carsWantedSlider.push(
                {
                  image: elem,
                  subline: '_OVERVIEW.SLIDER.CARS_WANTED.SUBLINE',
                  value: this.wantedItems.length
                }
              );
            }
          );
        }
      }
    );
  }

}
